import styled from '@emotion/styled'

interface IProps {
  clickable: boolean
  height: number
  width: number
}

export const Image = styled.img<IProps>`
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  margin: auto auto 0 auto;

  ${({ clickable }) => (clickable ? 'cursor: pointer;' : null)};
`
